import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { toast } from 'react-toastify';
import voca from 'voca';
import {
  dynamicSort,
  getProtocol,
  makePostCall,
  pushToGithub,
  trackPublish,
} from '../../common/utils/api_utils';
import './plugins/form/index';
import './plugins/dataTable/index';
import './plugins/dataGroup/index';
import './plugins/browserStorageSetter/index';
import './plugins/collectionForm/index';
import './plugins/loginPlugin/loginForm/index';
import './plugins/loginPlugin/userSignUpForm/index';
import './plugins/loginPlugin/changePassword/index';
import './plugins/collectionTraits/index';
import './plugins/collectionImageTraits/index';
import './plugins/iframeTraits/index';
import './plugins/collectionVideoTraits/index';
import './plugins/eventTraits/index';
import './plugins/snippet/index';
import './plugins/subPage/index';
import './plugins/customComponent/index';
import './plugins/customSegment/index';
import './plugins/hrefTraits/index';
import './plugins/subscriberForm/index';
import './plugins/pagination/index';
import './plugins/dateRangeComponent/index';
import './plugins/stripe-payment/index';
import './plugins/icons/index';
import './plugins/progressBar/index';
import './plugins/plaid/index';
import './plugins/searchForm/index';
import './plugins/dataMap/index';
import './plugins/dataGroupMap/index';
import './plugins/innerDataGroup/index';
import './plugins/innerDataList/index';
import './plugins/pageSearchForm/index';
import './plugins/preBuiltSection/index';
import './plugins/themePage/index';
import './plugins/market-place-cart';
import './plugins/carouselTraits/index';
import './plugins/cardsTraits/index';
import './plugins/addRemoveCollectionForm/index';
import './plugins/chat/atomchat/index';
import './plugins/chart/index';
import './plugins/preBuiltClassesTraits/index';
import './plugins/collectionAudioTraits/index';
import './plugins/snipcart-ecommerce/index';
import './plugins/stripe-connect/index';
import './plugins/dataGroupExternalAPI/index';
//import './plugins/autocomplete/index';
import './plugins/autocompleteInput/index';
import './plugins/exportButton/index';
import './plugins/paginationNumber/index';
import './plugins/bng-payment/index';
import './plugins/fluid-pay/index';
import './plugins/dataTableDynamic/index';
import './plugins/userTenantDropdown/index';
import './plugins/calendar/index';
import './plugins/calendarTimeslot/index';
import './plugins/permission/index';
import './plugins/chatbotMessage/index';
import './plugins/roleMappingDropdown/index';
import './plugins/messaging/index';
import './plugins/totp';
import './plugins/imagine-pay';
import './plugins/actionSubmit';
import './plugins/pageList';
import './plugins/pdfViewer/index';
import './plugins/stripe-payment-methods/index';
import './plugins/stripe-payment-methods-list/index';
import './plugins/otpAuthenticator/index';
import './plugins/otpGenerationForm/index';
import './plugins/aiComponents/index';
import './plugins/typesenseSearch/index';
import './plugins/subTenantDropdown/index';
import './plugins/paginationPageSize/index';
import './plugins/socketAlert/index';
import './plugins/aiChatBot/index';
import './plugins/box/index';
import './plugins/notesWidget/index';
import './plugins/signature-pad/index';
import {
  buildBoxStyles,
  cleanBlockCategories,
  configureEditor,
  delay,
  managePanelButtons,
} from '../../common/utils/geditor_utils';
import { getPageCollectionFields, getSnippetCollectionFields } from './apiUtils';
import { getCustomFormThemesStyle, loadCustomCSSClasses } from './plugins/pluginComponentApi';
import geditorBuilder, { resetGeditor } from './geditorBuilder';
import { filterByKey } from '../../common/utils/api_utils';
import { showWarning } from '../../common/utils/alert';
import {
  checkGithubPermission,
  getCookie,
  isProjectReadOnly,
  loadOrganizationDetails,
} from '../home/app_util';
import PublishProjectModal from './PublishProjectModal';
import PreviewProjectModal from './PreviewProjectModal';
import {
  getRedirectUrl,
  prepExchangeEngineUrl,
  prepExchangeSurfaceUrl,
} from '../../common/utils/environmentUtils';

class GEditor extends Component {
  _isMounted = false; // Flag to track if component is mounted

  static propTypes = {
    projectId: PropTypes.string.isRequired,
    uri: PropTypes.string.isRequired,
    project: PropTypes.object.isRequired,
    editor: PropTypes.object.isRequired,
  };

  state = {
    editor: null,
    editorDoc: null,
    editorWindow: null,
    displayBlock: false,
    bindCollectionOptions: null,
    menu: [{ label: 'Create Page' }, { label: 'Context menu is fun' }, { label: 'Cool' }],
    popoverOpen: false,
    isPublishing: false,
    previewModalOpen: false,
    previewUrl: '',
    selVersion: {
      ALPHA: this.props.version,
      BETA: this.props.version,
      PREVIEW: this.props.version,
      PRODUCTION: this.props.version,
    },
  };

  async componentDidMount() {
    const {
      pageId,
      projectId,
      uri,
      editor,
      version,
      plugins,
      // actions
    } = this.props;
    const {
      pages,
      loadInstalledPluginsPending,
      loadExternalApisPending,
      loadEventsPending,
      loadCollectionsPending,
    } = editor;
    const currentPage = filterByKey(pages, 'uuid', pageId);
    // await actions.loadInstalledPlugins({ projectId, version });
    // const { plugins } = this.props;
    // if ((!editor.plugins || editor.plugins.length === 0) && plugins.length) {
    //   editor.plugins = [...plugins];
    // }

    console.log(
      '🚀 ~ GEditor ~ componentDidMount ~ loadInstalledPluginsPending:',
      loadInstalledPluginsPending,
      '~ loadExternalApisPending:',
      loadExternalApisPending,
      '~ loadEventsPending:',
      loadEventsPending,
      '~ loadCollectionsPending:',
      loadCollectionsPending,
    );

    const loaded =
      !loadInstalledPluginsPending &&
      !loadExternalApisPending &&
      !loadEventsPending &&
      !loadCollectionsPending;
    console.log('🚀 ~ GEditor ~ componentDidMount ~ loaded:', loaded);

    // this._isMounted = true; // Set flag on mount
    this._isMounted = loaded; // Set flag on mount
    if (loaded) {
      console.log('%c🚀 ~ GEditor ~ componentDidMount plugins:', 'color:yellow', plugins);
      this.loadTraitOptions(pageId, projectId, version, uri, editor, currentPage);
    }
  }

  componentWillUnmount() {
    this._isMounted = false; // Unset flag on unmount
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.uri !== this.props.uri) {
      const { editor, projectId, plugins, version } = this.props;
      const { pageId, uri } = nextProps;
      const {
        pages,
        loadInstalledPluginsPending,
        loadExternalApisPending,
        loadEventsPending,
        loadCollectionsPending,
      } = editor;
      const currentPage = filterByKey(pages, 'uuid', pageId);
      const loaded =
        !loadInstalledPluginsPending &&
        !loadExternalApisPending &&
        !loadEventsPending &&
        !loadCollectionsPending;
      console.log('🚀 ~ shouldComponentUpdate ~ loaded:', loaded);
      this.loadTraitOptions(pageId, projectId, version, uri, editor, currentPage);
    }
    return true;
  }

  componentDidUpdate(prevProps) {
    const isNextEvents =
      prevProps.editor.events &&
      this.props.editor.events &&
      prevProps.editor.events.length !== this.props.editor.events.length;
    if (isNextEvents) {
      const { editor, projectId, version, pageId, uri } = this.props;
      const {
        pages,
        loadInstalledPluginsPending,
        loadExternalApisPending,
        loadEventsPending,
        loadCollectionsPending,
      } = editor;
      const currentPage = filterByKey(pages, 'uuid', pageId);
      const loaded =
        !loadInstalledPluginsPending &&
        !loadExternalApisPending &&
        !loadEventsPending &&
        !loadCollectionsPending;
      console.log('🚀 ~ componentDidUpdate ~ loaded:', loaded);
      this.loadTraitOptions(pageId, projectId, version, uri, editor, currentPage);
    }
  }

  toggle = () => {
    this.setState({ popoverOpen: !this.state.popoverOpen });
  };

  handleVersionChange = (event, type) => {
    const { selVersion } = this.state;
    const {
      target: { value },
    } = event;
    selVersion[type] = value;
    this.setState({ selVersion });
  };

  togglePreview = (previewUrl) => {
    this.setState({ previewModalOpen: !this.state.previewModalOpen, previewUrl });
  };

  createEditor = async (
    uri,
    collections,
    events,
    externalApis,
    bindCollectionOptions,
    installedPlugins,
    slug,
    snippetCollectionTraitOptions,
  ) => {
    const { assets, project, projectId, token, version, versions } = this.props;

    // Early return if essential props are missing
    if (!uri || !projectId || !version || !collections) return null;

    // Clear blocks and layer manager only if they exist
    $('#blocks').length && $('#blocks').html('');
    $('#layer-manager').length && $('#layer-manager').html('');

    resetGeditor();
    const geditorBuilderOption = {
      uri,
      projectId,
      version,
      token,
      collections,
      events,
      externalApis,
      assets,
      bindCollectionOptions,
      installedPlugins,
      snippetCollectionTraitOptions,
      project,
    };

    let { editor } = this.state;
    editor = geditorBuilder(geditorBuilderOption);

    // Remove layers panel button if it exists
    if (editor && editor.Panels) {
      editor.Panels.removeButton('views', 'open-layers');
      await managePanelButtons(editor);
    }

    // Use async delay instead of setTimeout
    await delay(1000);
    configureEditor(
      editor,
      project,
      version,
      versions,
      this.toggle,
      slug,
      this.togglePreview,
      geditorBuilderOption,
    );

    return editor;
  };

  loadTraitOptions = async (pageId, projectId, version, uri, editor, currentPage) => {
    try {
      console.log('🚀 ~ GEditor ~ editor:', editor);
      const {
        plugins,
        collections,
        externalApis,
        events,
        loadInstalledPluginsPending,
        loadExternalApisPending,
        loadEventsPending,
        loadCollectionsPending,
      } = editor;
      console.log(
        '🚀 ~ GEditor ~ loadInstalledPluginsPending:',
        loadInstalledPluginsPending,
        '~ loadExternalApisPending:',
        loadExternalApisPending,
        '~ loadEventsPending:',
        loadEventsPending,
        '~ loadCollectionsPending:',
        loadCollectionsPending,
        '~ this._isMounted:',
        this._isMounted,
      );
      // Clean up collections
      if (collections && collections.length) {
        collections.forEach((coll) => {
          delete coll['_id'];
          delete coll['__v'];
          delete coll['constructors'];
        });
      }
      const isSnippet = uri && uri.includes('snippet-templates'); // Check if the URI indicates a snippet template

      console.log('%c🚀 ~ GEditor ~ isSnippet:', 'color:yellow', isSnippet);

      const loginSignUp = plugins.find((e) => e.code === 'LOGIN');
      const multiTenantPlugin = plugins.find((e) => e.code === 'MULTI_TENANT_SAAS');

      let collectionTraitOptions = {};
      let snippetCollectionTraitOptions = {};
      // TODO: Refactor this to avoid unnecessary API calls and Fetch collection trait options in a better way
      snippetCollectionTraitOptions = await getSnippetCollectionFields(
        pageId,
        projectId,
        version,
        collections,
      );
      collectionTraitOptions = await getPageCollectionFields(
        pageId,
        projectId,
        version,
        loginSignUp,
        collections,
        multiTenantPlugin,
      );
      let page = currentPage;
      if (!page && collectionTraitOptions && collectionTraitOptions.page) {
        page = collectionTraitOptions.page;
      }
      let snippet = '';
      if (snippetCollectionTraitOptions && snippetCollectionTraitOptions.snippet) {
        snippet = snippetCollectionTraitOptions.snippet;
      }
      const slug = page ? page.slug : '';

      const drapcodeEditor = await this.createEditor(
        uri,
        collections,
        events,
        externalApis,
        collectionTraitOptions,
        plugins,
        slug,
        snippetCollectionTraitOptions,
      );

      await this.initializeEditor(drapcodeEditor, projectId, version, page, snippet);

      const switchVersionBtn = document.getElementById('switch-version');
      if (switchVersionBtn) {
        switchVersionBtn.innerHTML = ` (v${version})`;
      }
    } catch (error) {
      console.error('Error loading trait options:', error);
    }
  };

  initializeEditor = async (editor, projectId, version, currentPage, currentSnippet) => {
    const canvas = editor.Canvas;
    const editorDoc = canvas.getDocument();
    const editorWindow = canvas.getWindow();
    const isReadOnly = isProjectReadOnly(projectId);
    cleanBlockCategories();
    // Wait for 1 second before initializing
    await delay(1000);
    console.log('%c🚀 ~ GEditor ~ Initializing Editor...', 'color:yellow');
    await Promise.all([
      this.loadCustomFormThemes(editor),
      this.setProjectCustomCSSCdn(editor),
      this.loadProjectCustomCss(editor),
      this.loadCustomCSSClasses(editor, projectId, version),
      this.loadProjectCustomThemeCSS(editor),
      this.loadSnippetCustomStyle(editor, currentSnippet),
      this.setPageDirection(editor, currentPage),
      this.setProjectCustomJSCdn(editor),
      this.setProjectCustomScript(editor),
      this.setPageExternalScriptUrl(editor, currentPage),
    ]);
    console.log('%c🚀 ~ GEditor ~ isMounted:', 'color:yellow', this._isMounted);
    if (this._isMounted) {
      // Only update state if mounted
      this.setState({
        editor,
        editorDoc,
        editorWindow,
      });
    }

    console.log('%c🚀 ~ GEditor ~ Loaded Builder Canvas...', 'color:yellow');
    await managePanelButtons(editor, false, isReadOnly);
  };

  appendStyle = (editor, customCSS, appendInBody = false) => {
    let rootStyle = document.createElement('style');
    rootStyle.appendChild(document.createTextNode(customCSS));
    const canvas = editor.Canvas;
    const iframe = canvas.getFrameEl();
    if (iframe && iframe.contentDocument) {
      if (appendInBody) {
        iframe.contentDocument.body.appendChild(rootStyle);
      } else {
        iframe.contentDocument.head.appendChild(rootStyle);
      }
    }
  };

  loadProjectCustomCss = async (editor) => {
    const project = this.props.project;
    const { content } = project ? project : {};
    const { customCSS } = content ? content : {};
    let contentCustomCSS = customCSS ? customCSS : '';
    this.appendStyle(editor, contentCustomCSS);
  };

  loadSnippetCustomStyle = async (editor, currentSnippet) => {
    const { customStyle } = currentSnippet;
    let contentCustomCSS = customStyle ? customStyle : '';
    this.appendStyle(editor, contentCustomCSS);
  };

  generateCustomThemeCSS = (theme) => {
    const generateButtonSpacingStyles = () => {
      let buttonStyles = '';

      buttonStyles += `.btn { ${buildBoxStyles('Margin', theme)} }`;
      buttonStyles += `.btn { ${buildBoxStyles('Padding', theme)} }`;

      // if (theme.Margin) {
      //   buttonStyles += `.btn { margin: ${theme.Margin}; }`;
      // } else if (theme.MarginTop || theme.MarginRight || theme.MarginBottom || theme.MarginLeft) {
      //   buttonStyles += `.btn {
      //     margin: ${theme.MarginTop || '0'} ${theme.MarginRight || '0'} ${
      //     theme.MarginBottom || '0'
      //   } ${theme.MarginLeft || '0'};
      //   }`;
      // }

      // if (theme.Padding) {
      //   buttonStyles += `.btn { padding: ${theme.Padding}; }`;
      // } else if (
      //   theme.PaddingTop ||
      //   theme.PaddingRight ||
      //   theme.PaddingBottom ||
      //   theme.PaddingLeft
      // ) {
      //   buttonStyles += `.btn {
      //     padding: ${theme.PaddingTop || '0'} ${theme.PaddingRight || '0'} ${
      //     theme.PaddingBottom || '0'
      //   } ${theme.PaddingLeft || '0'};
      //   }`;
      // }

      if (theme.Border) {
        buttonStyles += `.btn { border: ${theme.Border} solid currentColor; }`;
      } else if (theme.BorderTop || theme.BorderRight || theme.BorderBottom || theme.BorderLeft) {
        buttonStyles += `.btn { 
          border-width: ${theme.BorderTop || '0'} ${theme.BorderRight || '0'} ${
          theme.BorderBottom || '0'
        } ${theme.BorderLeft || '0'}; 
          border-style: solid; 
          border-color: currentColor; 
        }`;
      }

      if (theme.BorderRadius) {
        buttonStyles += `.btn { border-radius: ${theme.BorderRadius}; }`;
      } else {
        const borderRadius = [
          theme.BorderRadiusTop || '0',
          theme.BorderRadiusRight || '0',
          theme.BorderRadiusBottom || '0',
          theme.BorderRadiusLeft || '0',
        ].join(' ');

        if (borderRadius.trim() !== '0 0 0 0') {
          buttonStyles += `.btn { border-radius: ${borderRadius}; }`;
        }
      }

      return buttonStyles;
    };

    return `
  body {
    ${theme.body && theme.body.color ? `color: ${theme.body.color};` : ''}
    ${
      theme.body && theme.body.backgroundColor
        ? `background-color: ${theme.body.backgroundColor};`
        : ''
    }
    ${theme.bodyFont && theme.bodyFont.value ? `font-family: ${theme.bodyFont.value};` : ''}
  }
  a {
    ${theme.body && theme.body.anchor ? `color: ${theme.body.anchor};` : ''}
  }
  a:hover {
    ${theme.body && theme.body.anchorHover ? `color: ${theme.body.anchorHover};` : ''}
  }

  ${['h1', 'h2', 'h3', 'h4', 'h5', 'h6']
    .map(
      (tag) => `
      ${
        theme[tag + 'Font'] && theme[tag + 'Font'].value
          ? `${tag} { font-family: ${theme[tag + 'Font'].value}; }`
          : ''
      }
      ${theme[tag + 'FontSize'] ? `${tag} { font-size: ${theme[tag + 'FontSize']}; }` : ''}
      ${theme[tag + 'Color'] ? `${tag} { color: ${theme[tag + 'Color']}; }` : ''}
    `,
    )
    .join('')}

  ${['primary', 'danger', 'success', 'warning', 'info', 'light', 'dark', 'link']
    .map(
      (color) => `
      ${
        theme.colors && theme.colors[color]
          ? `.btn-${color} { background-color: ${theme.colors[color]}; }`
          : ''
      }
      ${
        theme.hoverColors && theme.hoverColors[color]
          ? `.btn-${color}:hover { background-color: ${theme.hoverColors[color]}; }`
          : ''
      }
    `,
    )
    .join('')}

  ${generateButtonSpacingStyles()}
`
      .replace(/\s+/g, ' ')
      .trim();
  };

  loadProjectCustomThemeCSS = async (editor) => {
    const project = this.props.project;
    const { customThemeProps } = project ? project : {};
    if (customThemeProps && Object.keys(customThemeProps).length > 0) {
      const customThemeCSS = this.generateCustomThemeCSS(customThemeProps);
      this.appendStyle(editor, customThemeCSS, true);
    }
  };

  loadCustomFormThemes = async (editor) => {
    const formThemesStyle = await getCustomFormThemesStyle();
    this.appendStyle(editor, formThemesStyle);
  };

  loadCustomCSSClasses = async (editor, projectId, version) => {
    const cssClasses = await loadCustomCSSClasses(projectId, version);
    this.appendStyle(editor, cssClasses);
  };

  setPageDirection = async (editor, currentPage) => {
    const canvas = editor.Canvas;
    let iframe = canvas.getFrameEl();
    const pageDirection = currentPage && currentPage.pageDirection ? currentPage.pageDirection : '';
    if (iframe && iframe.contentDocument && pageDirection) {
      iframe.contentDocument.body.setAttribute('dir', pageDirection);
    }
  };

  setPageExternalScriptUrl = async (editor, currentPage) => {
    const canvas = editor.Canvas;
    let iframe = canvas.getFrameEl();
    const { externalScriptURL } = currentPage ? currentPage : '';
    const externalScriptURLs = currentPage && externalScriptURL ? externalScriptURL.split(',') : '';
    externalScriptURLs &&
      externalScriptURLs.forEach((externalScriptURL) => {
        if (iframe && iframe.contentDocument && externalScriptURL) {
          const script = document.createElement('script');
          script.src = externalScriptURL.trim();
          script.async = true;
          script.defer = true;
          iframe.contentDocument.body.appendChild(script);
        }
      });
  };

  setProjectCustomCSSCdn = async (editor) => {
    const project = this.props.project;
    try {
      const { customCssCdns, loadAllCssCdnToBuilder } = project ? project : '';
      let projectCustomCssCdnsArr = [];

      if (project && customCssCdns && loadAllCssCdnToBuilder) {
        customCssCdns.map((customCssCdn) => {
          if (customCssCdn.loadToBuilder) {
            if (customCssCdn.sortOrder || customCssCdn.sortOrder === 0) {
              projectCustomCssCdnsArr.push(customCssCdn);
            } else {
              customCssCdn['sortOrder'] = 0;
              projectCustomCssCdnsArr.push(customCssCdn);
            }
          }
        });
      }
      let iframe = editor.Canvas.getFrameEl();
      projectCustomCssCdnsArr.sort(dynamicSort('sortOrder')).map((customCssCdn) => {
        if (customCssCdn.loadToBuilder && customCssCdn.urlOrTag.startsWith('<link')) {
          if (iframe && iframe.contentDocument && customCssCdn) {
            const iframeClass = iframe.className;
            const cssCdnString = customCssCdn.urlOrTag.trim();
            if (iframeClass && cssCdnString) {
              $(`.${iframeClass}`).contents().find('head').append(cssCdnString);
            }
          }
        } else if (
          customCssCdn.loadToBuilder &&
          (customCssCdn.urlOrTag.startsWith('http') || customCssCdn.urlOrTag.startsWith('ftp'))
        ) {
          if (iframe && iframe.contentDocument && customCssCdn) {
            const linkElem = document.createElement('link');
            linkElem.href = customCssCdn.urlOrTag.trim();
            linkElem.rel = 'stylesheet';
            linkElem.crossorigin = true;
            iframe.contentDocument.head.appendChild(linkElem);
          }
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  setProjectCustomJSCdn = async (editor) => {
    const project = this.props.project;
    const canvas = editor.Canvas;
    let iframe = canvas.getFrameEl();
    try {
      const { customJsCdns, loadAllJsCdnToBuilder } = project ? project : '';
      let projectCustomJsCdnsArr = [];
      if (project && customJsCdns && loadAllJsCdnToBuilder) {
        customJsCdns.map((customJsCdn) => {
          if (customJsCdn.loadToBuilder) {
            if (customJsCdn.sortOrder || customJsCdn.sortOrder === 0) {
              projectCustomJsCdnsArr.push(customJsCdn);
            } else {
              customJsCdn['sortOrder'] = 0;
              projectCustomJsCdnsArr.push(customJsCdn);
            }
          }
        });
      }

      projectCustomJsCdnsArr.sort(dynamicSort('sortOrder')).map((customJsCdn) => {
        if (customJsCdn.loadToBuilder && customJsCdn.urlOrTag.startsWith('<script')) {
          const scriptTagOpen = '<script';
          const scriptTagClose = '></script>';
          let scriptCdnTagContent = customJsCdn.urlOrTag
            .trim()
            .replace(scriptTagOpen, '')
            .replace(scriptTagClose, '');
          if (iframe && iframe.contentDocument && customJsCdn) {
            const iframeClass = iframe.className;
            const scriptString = '<scr' + 'ipt' + scriptCdnTagContent + '></scr' + 'ipt>';
            if (iframeClass && scriptString) {
              $(`.${iframeClass}`).contents().find('body').append(scriptString);
            }
          }
        } else if (
          customJsCdn.loadToBuilder &&
          (customJsCdn.urlOrTag.startsWith('http') || customJsCdn.urlOrTag.startsWith('ftp'))
        ) {
          if (iframe && iframe.contentDocument && customJsCdn) {
            const scriptElem = document.createElement('script');
            scriptElem.src = customJsCdn.urlOrTag.trim();
            // scriptElem.async = true;
            scriptElem.defer = true;
            iframe.contentDocument.body.appendChild(scriptElem);
          }
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  setProjectCustomScript = async (editor) => {
    const project = this.props.project;
    const canvas = editor.Canvas;
    let iframe = canvas.getFrameEl();
    try {
      const { content, loadCustomJsToBuilder } = project ? project : '';
      const { customJS } = content ? content : '';
      const customScriptContent =
        project && loadCustomJsToBuilder && content && customJS ? customJS.trim() : '';
      if (iframe && iframe.contentDocument && customScriptContent) {
        let clearScriptTags = customScriptContent.startsWith('<script>')
          ? customScriptContent.replace('<script>', '')
          : customScriptContent;
        clearScriptTags = clearScriptTags.endsWith('</script>')
          ? clearScriptTags.replace('</script>', '')
          : clearScriptTags;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.appendChild(document.createTextNode(clearScriptTags));
        iframe.contentDocument.body.appendChild(script);
      }
    } catch (error) {
      console.error(error);
    }
  };

  generateProjectURL = (envType, domainName, seoName, slug = '', link = false) => {
    let url = prepExchangeSurfaceUrl(seoName, envType);

    if (slug) {
      url += `${slug}`;
    }
    let protocol = `https`;
    let environment = process.env.REACT_APP_ENVIRONMENT || '';
    if (environment) {
      environment = environment.toLowerCase().trim();
    }
    //Overriding Exchange Surface URL protocol for DEV environment
    if (environment.startsWith('dev')) {
      protocol = `http`;
    }

    if (link) {
      return `${protocol}://${url}`;
    }
    return (
      <>
        <i className="wb webconnect-box-arrow-in-up-right" title="Open link in new tab"></i>
        <a
          className="icon-link"
          href={`${protocol}://${url}`}
          target="_blank"
          title="Open link in new tab"
        >
          {`${protocol}://${url}`}
        </a>
      </>
    );
  };

  publishApp = async (envType, name, cleanPublish) => {
    const { project, actions } = this.props;
    if (!project) {
      return '';
    }

    let selVersion = this.state.selVersion[envType];
    if (!selVersion) {
      selVersion = 1;
    }
    let exchangeEngineUrl = prepExchangeEngineUrl(envType);
    const protocol = getProtocol();
    const preConfirm = async () => {
      this.setState({ isPublishing: true });

      const { seoName, uuid } = project;
      try {
        toast.info('Started Publishing the Application.');
        await actions.updateLatestPublishVersion({
          projectId: uuid,
          latestVersion: selVersion,
          envType,
        });
        await trackPublish({ uuid, selVersion, envType });
        const publishUrl = `${protocol}://${seoName}.${exchangeEngineUrl}api/v1/projects/build/${uuid}/version/${selVersion}`;
        const publishBody = {
          subscription: loadOrganizationDetails('subscription'),
          cleanPublish: cleanPublish,
        };
        const header = { headers: { 'Content-Type': 'application/json', projectId: uuid } };
        const data = await makePostCall(publishUrl, publishBody, header, 'PUBLISH');
        this.setState({ isPublishing: false });
        if (!data || !data.success) {
          toast.error(data.message, {});
          return data;
        }

        if (data.message === 'Build Success') {
          toast.success('Application Published Successfully!');
          const isAllowedGithub = checkGithubPermission();
          if (isAllowedGithub) {
            await pushToGithub(protocol, seoName, exchangeEngineUrl, envType, uuid);
          }
          // await trackPublish({ uuid, selVersion, envType });
          return { success: true, data: data };
        }
      } catch (error) {
        this.setState({ isPublishing: false });
        return { success: false, error: error.message };
      }
    };

    if (envType === 'PREVIEW') {
      return await preConfirm();
    } else {
      const text = `You are going to publish the project in ${name}:(${voca.titleCase(
        envType,
      )}) environment. Are you sure?`;
      showWarning(text, preConfirm, 'Publish');
    }
  };

  showPopoverContent = () => {
    const { project, projectId, versions, pageId, editor, version, actions } = this.props;
    if (!project) {
      return '';
    }
    const redirectUrl = getRedirectUrl();
    let token = getCookie('token');
    const { pages } = editor;
    const currentPage = filterByKey(pages, 'uuid', pageId);
    const slug = currentPage ? currentPage.slug : '';
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <PublishProjectModal
        project={project}
        popoverOpen={this.state.popoverOpen}
        redirectUrl={redirectUrl}
        projectId={projectId}
        token={token}
        toggle={this.toggle}
        generateProjectURL={this.generateProjectURL}
        selVersion={this.state.selVersion}
        handleVersionChange={this.handleVersionChange}
        versions={versions}
        publishApp={this.publishApp}
        isPublishing={this.state.isPublishing}
        slug={slug}
        version={version}
        actions={actions}
        isReadOnly={isReadOnly}
      />
    );
  };

  showPreviewModalContent = () => {
    const { project, versions, pageId, editor, version, actions, projectId } = this.props;
    if (!project) {
      return '';
    }

    const { pages } = editor;
    const currentPage = filterByKey(pages, 'uuid', pageId);
    const slug = currentPage ? currentPage.slug : '';
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <PreviewProjectModal
        project={project}
        previewModalOpen={this.state.previewModalOpen}
        togglePreview={this.togglePreview}
        generateProjectURL={this.generateProjectURL}
        selVersion={this.state.selVersion}
        handleVersionChange={this.handleVersionChange}
        versions={versions}
        publishApp={this.publishApp}
        isPublishing={this.state.isPublishing}
        slug={slug}
        version={version}
        actions={actions}
        projectId={projectId}
        isReadOnly={isReadOnly}
      />
    );
  };

  render() {
    return (
      <>
        <div id="gjs" />
        <div id="publish-popover"></div>
        {this.showPopoverContent()}
        {this.showPreviewModalContent()}
      </>
    );
  }
}

export default GEditor;
